export const baseUrl = `${process.env.REACT_APP_PROD_API_URL}`;
export const baseUrlData = `${process.env.REACT_APP_PROD_API_DATA_URL}`;
export const baseUrls =`${process.env.REACT_APP_API_BASE_URL}`;
export const projectApiKey =
  "8cfb0bcbb28486343971777480fc510f2c22cc2738f512c6d5e754c7b96f2c0d";
